import React, {useState, useRef, useEffect} from 'react';
import { useDispatch } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import WpAPI from '../../WpApi';
import { LOGIN_LINK,LOGOUT_LINK, SIGNUP_LINK, EDIT_PROFILE, CHANGE_PASSWORD, MEMBERSHIP, INVOICES, MY_ACCOUNT, DASHBOARD_LINK, PAID_SERVICES, CREATE_RESUME, COOKIE_DOMAIN } from '../../constants/constants';
import '../../../src/assets/scss/common/_navbar.scss';
import UserIcon from '../../../src/assets/images-new/icons/user-icon.svg';
import { saveResume as saveResumeAction, PREVIEW_RESUME } from '../../services/actions/actions';
import { getDateTime } from '../../helper';
import { useUser } from '../../context/UserContext';
import jsCookie from 'js-cookie';
import PageLoader from './PageLoader';

const HeaderNavbar = () => {
    const history = useHistory();
    const [topNav, setTopNav] = useState(false);
    const [loader, setLoader] = useState({download: false, save: false, share: false, print: false});
    const {
        checkMembership,
        plan
    } = useUser();

    const dispatch = useDispatch()
    const ref = useRef(null);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (ref.current && !ref.current.contains(event.target)) {
                setTopNav(false);
            }
        };
        document.addEventListener('click', handleClickOutside, true);
        return () => {
            document.removeEventListener('click', handleClickOutside, true);
        };
    });

    const checkMembershipAction = (callback = false, params = false) => {
        if(typeof callback == 'function') setLoader({...loader, [callback.name]: true});
        checkMembership(() => {
            if(typeof callback == 'function'){
            callback(params);
            setLoader({...loader, [callback.name]: false});
            }
        });
    }

    const toggleTopNav = () => {
        if(!topNav && window.location.href.match('/editor/') !== null){
            //Save the page before user quite the page by clicking any link in nav
            dispatch(saveResumeAction(
                { modified_date: getDateTime() },
                PREVIEW_RESUME,
                true
            ));
        }
        setTopNav(!topNav);
    }

    const NavListWithLogin = () => {
        if(!plan)
            return <PageLoader />
        return (<>
            <ul>
                <li>
                    <Link
                        className={history.location.pathname == '/' ? ' active' : ''}
                        to="/"
                        onClick={() => {
                            gaTrack('RB App', `Header Menu`, 'My Resumes');
                            ga4Track('app_header_menu_my_resumes', 'RB App', 'My Resumes');
                            jsCookie.remove('dashboard_tab', { domain: COOKIE_DOMAIN, path: "/" })
                            const letterTab = document.querySelector('.tabs #lettertab');
                            if(window.location.pathname == '/' && letterTab?.classList?.contains('active'))  {
                                window.location.href='/'
                            }
                        }} >My Resumes</Link>
                </li>
                {/* {PAID_SERVICES && <li>
                    <Link 
                    className={history.location.pathname.includes(INVOICES) ? ' active' : ''}
                    to={INVOICES}
                    onClick={() => {
                        gaTrack('RB App', `Header Menu`, 'Invoices');
                        ga4Track('app_header_menu_invoices', 'RB App', 'Invoices');
                    }}>Invoices</Link>
                </li>} */}
                <li>
                    <Link 
                    className={history.location.pathname.includes(MY_ACCOUNT) ? ' active' : ''}
                    to={MY_ACCOUNT}
                    onClick={() => {
                        gaTrack('RB App', `Header Menu`, 'My Account');
                        ga4Track('app_header_menu_my_account', 'RB App', 'My Account');
                    }}>My Account</Link> 
                </li>
                {(PAID_SERVICES && plan !== 'pro') && <li>
                    <Link 
                    className={history.location.pathname.includes(MEMBERSHIP) ? ' active' : ''}
                    to={MEMBERSHIP}
                    onClick={() => {
                        ga4Track('app_account_menu_upgrade_plan', 'RB App', 'Account Menu: Upgrade Plan');
                    }}>Upgrade Plan</Link> 
                </li>}
                <li>
                    <Link to={CREATE_RESUME}>Create a New Resume</Link> 
                </li>
                <li>
                    <Link to={LOGOUT_LINK}>Log Out</Link> 
                </li>
            </ul>
        </>)
    }

    const NavListWithoutLogin = () => {
        return (<>
            <ul>
                <li onClick={() =>{
                   
                    ga4Track('app_all_pages_top_nav_sign_up', 'RB App', 'Top Nav: Sign Up');
                }}><Link to={SIGNUP_LINK}>Sign Up</Link></li>
                <li onClick={() =>{
                    ga4Track('app_all_pages_top_nav_login', 'RB App', 'Top Nav: Login');
                }}><Link to={LOGIN_LINK}>Login</Link></li>
            </ul>
        </>)
    }

    const NavList = () => {
        return (<>
        {window.innerWidth < 769 ?
            topNav && (WpAPI.isLoggedIn() ? <NavListWithLogin /> : <NavListWithoutLogin />)
            : (WpAPI.isLoggedIn() ? <NavListWithLogin />: <NavListWithoutLogin />)
        }
        </>)
    }

    return (<>
        {/* <div ref={ref} className={`toggle-nav-btn${topNav ? ' close-icon' : ''}`} onClick={() => setTopNav(!topNav)}>
            <span></span>
            <span></span>
            <span></span>
        </div> */}
        <div ref={ref} className="desktop-menus" onClick={() => {
            //PAID_SERVICES ? checkMembershipAction(toggleTopNav) : toggleTopNav();
            toggleTopNav();

        }}>
            {/*Remove profile icon and menu from traditional editor for all users */}
            {window.location.pathname == '/' || ((window.location.pathname).indexOf('/editor/allinone') > -1) || ((window.location.pathname).indexOf('/quick-editor/') > -1) ? <> <span className={`user-icon${topNav ? ' arrow-change' : ''}`}><UserIcon /><i className="u-arrow-icon"></i></span>
            <div className={`block-list${topNav ? ' display-menu' : ''}`}> 
                <NavList />
                </div></> : ''}
        </div>
        {/* <nav className={`top-nav${topNav ? ' display-mobile-nav' : ''}`}>
            <NavList />
        </nav> */}

    </>);

}

export default HeaderNavbar;